class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('details-modal', DetailsModal);


$(".details_open").click(function(){
  var href = $(this).find("summary").attr("href");
  window.location.replace(href)
})

// 导航
$(".mega_leftBox_small").mouseover(function(){
  $(this).addClass("active").siblings().removeClass("active");
  var index = $(this).index();
  $(this).parents(".mega_Box").find(".mega_rightBox:eq("+index+")").addClass("active").siblings().removeClass("active");
})

// 导航
$(".menu_drawerSubmenu_box:eq(0)").addClass("active");
$(".menu_drawerSubmenu_box:eq(0) .menuDrawer_text").show();
$(".menu_drawerSubmenu_title").click(function() {
  // 修正1：获取正确的父级容器
  var $parentBox = $(this).closest(".menu_drawerSubmenu_box");
  // 修正2：获取实际子菜单元素
  var $submenu = $parentBox.find(".menuDrawer_text");
  
  if ($parentBox.hasClass("active")) {
      // 关闭当前菜单
      $parentBox.removeClass("active");
      $submenu.slideUp();
  } else {
      // 修正3：精确筛选兄弟元素
      $parentBox.siblings(".menu_drawerSubmenu_box")
          .removeClass("active")
          .find(".menuDrawer_text").slideUp();
      // 展开当前菜单
      $parentBox.addClass("active");
      $submenu.slideDown();
  }
});